export const TABLE_HEAD = {
  noTablecolumn: [
    {
      title: '教师名称',
      dataIndex: 'teacherName',
      colKey: 'teacherName',
      align: 'left',
    },
    {
      title: '班级名称',
      dataIndex: 'className',
      colKey: 'className',
      align: 'left',
    },
    {
      title: '学科',
      dataIndex: 'subjectName',
      colKey: 'subjectName',
      align: 'left',
    },
    {
      title: '发起课堂数',
      dataIndex: 'platformCourseNum',
      colKey: 'platformCourseNum',
      align: 'left',
    },
    {
      title: '未调用学程课堂数',
      dataIndex: 'notUseCourseNum',
      colKey: 'notUseCourseNum',
      align: 'left',
    },
    {
      title: '未发起展示课堂数',
      dataIndex: 'notUsePresentationNum',
      colKey: 'notUsePresentationNum',
      align: 'left',
    },
    {
      title: '未发起资源推送课堂数',
      dataIndex: 'noResourcePushNum',
      colKey: 'noResourcePushNum',
      align: 'left',
    },
    {
      title: '未发起课堂评价课堂数',
      dataIndex: 'notUseEvaluationNum',
      colKey: 'notUseEvaluationNum',
      align: 'left',
    },
  ],
  tablecolumn: [
    {
      title: '教师名称',
      dataIndex: 'teacherName',
      colKey: 'teacherName',
      align: 'left',
    },
    {
      title: '班级名称',
      dataIndex: 'className',
      colKey: 'className',
      align: 'left',
    },
    {
      title: '学科',
      dataIndex: 'subjectName',
      colKey: 'subjectName',
      align: 'left',
    },
    {
      title: '发起课堂数',
      dataIndex: 'platformCourseNum',
      colKey: 'platformCourseNum',
      align: 'left',
    },
    {
      title: '调用学程课堂数',
      dataIndex: 'useCourseNum',
      colKey: 'useCourseNum',
      align: 'left',
    },
    {
      title: '发起展示课堂数',
      dataIndex: 'usePresentationNum',
      colKey: 'usePresentationNum',
      align: 'left',
    },
    {
      title: '发起资源推送课堂数',
      dataIndex: 'resourcePushNum',
      colKey: 'resourcePushNum',
      align: 'left',
    },
    {
      title: '发起课堂评价课堂数',
      dataIndex: 'useEvaluationNum',
      colKey: 'useEvaluationNum',
      align: 'left',
    },
  ],
  teacherColumn: [
    {
      title: '学生姓名',
      dataIndex: 'studentName',
      colKey: 'studentName',
      align: 'left',
      width: '120px',
    },
    {
      title: '参与展示率',
      dataIndex: 'studentRate',
      colKey: 'studentRate',
      headerAlign: 'center',
      align: 'right',
      width: '120px',
    },
    {
      title: '课堂成果提交数',
      dataIndex: 'courseWorkNum',
      colKey: 'courseWorkNum',
      headerAlign: 'center',
      align: 'right',
      width: '160px',
    },
    {
      title: '课堂成果累计获赞数',
      dataIndex: 'courseWorkPraisedNum',
      colKey: 'courseWorkPraisedNum',
      headerAlign: 'center',
      align: 'right',
      width: '200px',
    },
    {
      title: '检测答题数',
      dataIndex: 'detectionNum',
      colKey: 'detectionNum',
      headerAlign: 'center',
      align: 'right',
      width: '120px',
    },
    {
      title: '检测正确率',
      dataIndex: 'detectionRate',
      colKey: 'detectionRate',
      headerAlign: 'center',
      align: 'right',
      width: '120px',
    },
    {
      title: '抢答成功次数',
      dataIndex: 'answerNum',
      colKey: 'answerNum',
      headerAlign: 'center',
      align: 'right',
      width: '160px',
    },
    {
      title: '参与演示次数',
      dataIndex: 'presentationNum',
      colKey: 'presentationNum',
      headerAlign: 'center',
      align: 'right',
      width: '160px',
    },
    {
      title: '推送资源个数',
      dataIndex: 'resourcePushNum',
      colKey: 'resourcePushNum',
      headerAlign: 'center',
      align: 'right',
      width: '160px',
    },
    {
      title: '推送资源个数',
      dataIndex: 'resourceViewNum',
      colKey: 'resourceViewNum',
      headerAlign: 'center',
      align: 'right',
      width: '160px',
    },
    {
      title: '推送资源查看数',
      dataIndex: 'resourceViewNum',
      colKey: 'resourceViewNum',
      headerAlign: 'center',
      align: 'right',
      width: '160px',
    },
    {
      title: '学程提交卡完成数',
      dataIndex: 'courseWorkCardNum',
      colKey: 'courseWorkCardNum',
      headerAlign: 'center',
      align: 'right',
      minWidth: '160px',
    },
  ],
}
